var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.assignment.is_kindle)?_c('div'):_c('div',{staticClass:"action download-manuscript",on:{"click":_vm.downloadManuscript}},[_vm._v("Download Book")])])}
var staticRenderFns = []

export { render, staticRenderFns }